'use client'

import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Flex,
    Text,
    Container, Heading, AccordionIcon, VStack, Box,
} from '@chakra-ui/react'

import { ChevronDownIcon } from '@chakra-ui/icons'
import {useTranslation} from "react-i18next";

export default function FAQPricing() {
    const {t} = useTranslation()

    const faqData = [
        {
            question: t("What is the cancellation policy?"),
            answer: t("You can cancel your Pro subscription at any time. If you cancel, you will still have access to your Pro plan until the end of the current 30-day billing period. To cancel your subscription, click on Manage Subscription in the top right menu with your name."),
        },
        {
            question: t("Is there a free trial?"),
            answer: t("No. Because we offer the free plan where you can already try out the product for free, you will be billed once you enter your payment information and subscribe to the Pro Plan. We hope you do!"),
        },
        {
            question: t("Is Justify available in other languages?"),
            answer: t("Yes, Justify can understand and respond in over 95 languages. You can upload any file or video in your preferred language, and also ask questions in your preferred language."),
        },
        {
            question: t("Is my data secure and confidential?"),
            answer: t("We take privacy and security very seriously. All documents and videos are fully encrypted and only you can access them. If you delete something, it is permanently deleted from our systems. In addition, all data is stored in AWS GovCloud storage that is secure and GDPR-compliant."),
        },
        {
            question: t("Is Justify accurate?"),
            answer: t("Yes. Unlike ChatGPT and other general-purpose AI tools, Justify has close to zero hallucinations and is customized to work well with police reports, direct uploads of body-worn camera videos, and other specific materials for private investigators."),
        },
        {
            question: t("What payment methods do you accept?"),
            answer: t("We use a secure payment processor, Stripe, to accept most major credit and debit cards."),
        },
        {
            question: t("Who do I contact if I have other issues or specific questions?"),
            answer: t("Please email: contact@justifyai.app, and we will get back to you as soon as possible."),
        },
    ];

    return (
        <Box bg="white" pb={10}>
            <Container maxW="4xl">
                <VStack spacing={10}>
                    <Heading size="xl" textAlign="center" color="#1e293b" fontWeight="bold">
                        Frequently Asked Questions
                    </Heading>

                    <Accordion allowToggle w="full">
                        {faqData.map((item, index) => (
                            <AccordionItem key={index} border="none" mb={4}>
                                <AccordionButton
                                    bg="#f1f5f9"
                                    _hover={{ bg: "#e2e8f0" }}
                                    borderRadius="lg"
                                    p={6}
                                    _expanded={{ bg: "#e2e8f0" }}
                                    border="1px"
                                    borderColor="#e2e8f0"
                                >
                                    <Box flex="1" textAlign="left">
                                        <Text fontWeight="medium" color="#1e293b">{item.question}</Text>
                                    </Box>
                                    <AccordionIcon fontSize="24px"/>
                                </AccordionButton>
                                <AccordionPanel pb={4}>
                                    <Text color="#64748b" lineHeight="1.6" mt={4} textAlign={'left'}>
                                        {item.answer}
                                    </Text>
                                </AccordionPanel>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </VStack>
            </Container>
        </Box>
    )
}
